var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAutomate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4375 4.5C3.30044 4.5 4 3.80044 4 2.9375C4 2.07456 3.30044 1.375 2.4375 1.375C1.57456 1.375 0.875 2.07456 0.875 2.9375C0.875 3.80044 1.57456 4.5 2.4375 4.5ZM2.4375 4.5V9.5M2.4375 9.5C1.57456 9.5 0.875 10.1996 0.875 11.0625C0.875 11.9254 1.57456 12.625 2.4375 12.625C3.30044 12.625 4 11.9254 4 11.0625C4 10.1996 3.30044 9.5 2.4375 9.5ZM10.5625 9.5V4.9375C10.5625 4.23744 10.5625 3.8874 10.4262 3.62001C10.3064 3.38481 10.1152 3.19358 9.88 3.07374C9.61263 2.9375 9.26256 2.9375 8.5625 2.9375H6.5M10.5625 9.5C11.4254 9.5 12.125 10.1996 12.125 11.0625C12.125 11.9254 11.4254 12.625 10.5625 12.625C9.69956 12.625 9 11.9254 9 11.0625C9 10.1996 9.69956 9.5 10.5625 9.5ZM6.5 2.9375L8.0625 4.5M6.5 2.9375L8.0625 1.375",
    stroke: "currentFill",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAutomate);
export default __webpack_public_path__ + "static/media/icon-automate.cfd4b824e21697413693eb2191452634.svg";
export { ForwardRef as ReactComponent };